export default __webpack_public_path__ + "static/media/vid1.e63c2e99.mp4";